import { KeyBooleanValuePair, KeyStringValuePair } from '@app/utils/util';

declare var TENANT_CONF: TenantConfig;

interface ImageConfig {
  light: {
    url: string;
  };
  dark: {
    url: string;
  };
  altText: string;
}

interface ModuleConfig {
  enabled: boolean;
  isDefault?: boolean; // Wether this module is the default route (i.e. home)
  apiPath: string;
  defaultPlaceId?: string;
  queryParams: KeyStringValuePair;
  placeholderImage?: string;
  header?: {
    headline: KeyStringValuePair;
    subHeader: KeyStringValuePair;
  };
  main?: {
    headline: KeyStringValuePair;
    searchHint: KeyStringValuePair;
  };
  footer: {
    addLink: {
      url: string;
    };
  };
  keywordSets?: {
    keywordIconClasses: KeyStringValuePair;
    ignoreKeywordIds: Array<string>;
    queryParams: KeyStringValuePair;
  };
}

export interface TenantConfig {
  api: {
    baseUrl: string;
  };
  modules: {
    [moduleName: string]: ModuleConfig;
  };
  site: {
    title: string;
    metaDescription: string;
    metaKeywords: string;
    copyrightText?: string;
    header: {
      logo: ImageConfig;
    };
    footer: {
      logo: ImageConfig;
    };
    defaultLanguage: string;
    dateFormat: string;
    timeFormat: string;
    dateTimeFormat: string;
  };
}

const tenantConfig = TENANT_CONF!;

export function getConfig(): TenantConfig {
  return tenantConfig;
}
